import './index.scss';
import { LoadingElement } from 'ii-react-sdk/layout_components';
import React from 'react';
import PermissionChecker from '~/components/permission_checker';
import Permissions from '~/settings/permissions';
import DocumentPanel from './document_panel';
import LeftPanel from './left_panel';
import { DocumentViewProvider, useDocumentView } from './providers';
const DocumentView = () => {
    const { document, fileName, pdf } = useDocumentView();
    if (!document || !fileName || !pdf) {
        return (React.createElement("div", { className: 'document-view-loading' },
            React.createElement(LoadingElement, { isLightBackground: true, large: true, text: 'Loading document...', heading: true })));
    }
    return React.createElement(PermissionChecker, { requiredAllPermissions: [Permissions.ACCESS_CLAUSELINK] },
        React.createElement("div", { className: 'single-document-view page-content-wrapper' },
            React.createElement(LeftPanel, { document: document }),
            React.createElement(DocumentPanel, { fileName: fileName, pdf: pdf })));
};
const DocumentViewWrapper = () => {
    return React.createElement(DocumentViewProvider, null,
        React.createElement(DocumentView, null));
};
export default DocumentViewWrapper;
